export default {
    online: ' 在线学中文 当然选',
    hatu: ' 哈兔',
    free: '免费',
    linqu: '领取价值188元试听体验',
    butfree: '免费领取',
    best: '最适合华人华侨子女的中文课程 ',
    personal: '自主研发',
    guding: '固定老师授课',
    fengfu: '课程丰富多样',
    genzong: '全程跟踪服务',

    study: '学中文 为什么选哈兔',
    study_item1_title: '多班型可选',
    study_item1_intro: '1对1，1对多多种班型多种选择',
    study_item2_title: '固定老师授课',
    study_item2_intro: '是老师更像是朋友陪伴孩子一路成长',
    study_item3_title: '课程丰富多样',
    study_item3_intro: '三大系列课程，体系完整有针对性的选择',
    study_item4_title: '个性化定制',
    study_item4_intro: '根据孩子的年龄、水平、学习目的匹配最适合的中文课程',
    study_item5_title: '全程跟踪服务',
    study_item5_intro: '专业的课程顾问老师全程跟踪服务',

    experience: '有趣的课堂体验',
    experience_item1_title: '自主研发课程',
    experience_item1_intro: '基于孩子认知和语言发展规律设计趣味性的课程',
    experience_item2_title: '游戏教学法',
    experience_item2_intro: '让孩子沉浸在玩与学中，充分吸收知识',
    experience_item3_title: '高频师生互动',
    experience_item3_intro: '欢乐互动，鼓励与表扬，让孩子爱上中文',

    teacher: '总有适合你的老师',
    teacher_extra: '录取率不到5%',
    teacher_intro1: '优质中文教师',
    teacher_intro2: '本科以上学历',
    teacher_intro3: '两年以上教学经验',
    teacher_intro4: '懂心理爱孩子',

    medie: '媒体报道',

    join: '加入哈兔大家庭',
    join_yu: '与',
    join_num: '多个国家和地区的学习者一起',
    join_start: '开启你的',
    join_study: '学习之旅',
    join_butt: '立即领取',

};